import React from 'react';
import PropTypes from 'prop-types';

export const arrowdown = ({ fillColor }) => (
    <svg viewBox='0 0 16 11' version='1.1' xmlns='http://www.w3.org/2000/svg'>
        <g fill={fillColor} fillRule='evenodd'>
            <polygon
                id='path-arrowdown'
                points='1.88 0 8 6.59289249 14.12 0 16 2.02968961 8 10.6666667 0 2.02968961'
            />
        </g>
    </svg>
);

arrowdown.propTypes = {
    fillColor: PropTypes.string.isRequired
};

export default arrowdown;
